import { useEffect, useState } from 'react';
import { api } from '../api/client.ts';
import { useSession } from '../state/session.tsx';

/**
 * Whether Visit coverage may be offered: the plan carries the staff portal,
 * this person may read it, and the deployment's capability endpoint answers.
 *
 * The answer is kept with the scope it was asked for (company, person,
 * location, role, permissions, plan), so a reply that lands after any of them
 * changed — a location switch that turns a manager into crew, access removed
 * — is never shown under the new one.
 */
export function useVisitCoverage(): boolean {
  const s = useSession();
  const scope = `${s.user?.companyId}:${s.user?.id}:${s.currentLocation?.id}:${s.user?.role}:${s.user?.permissions?.join(',')}:${s.company?.planFeatures?.join(',')}`;
  const allowed =
    s.company?.planFeatures?.includes('staff_portal') === true &&
    s.user?.permissions?.includes('staff_portal:read') === true;
  const [availableFor, setAvailableFor] = useState<string | null>(null);
  useEffect(() => {
    if (!allowed) return;
    let alive = true;
    void api
      .get('/staff/visit-offers/capability')
      .then(() => {
        if (alive) setAvailableFor(scope);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [allowed, scope]);
  return allowed && availableFor === scope;
}
